/* Exact watch references checked against the official manufacturer URLs below.
   Product links are based on Wellstraps descriptions, not physical fit testing.
   Add merchant-verified references through Header > Search reference in the theme editor. */
window.WellstrapsSearchData = {
  "version": 2,
  "checkedAt": "2026-10-22",
  "brands": [
    {
      "name": "Rolex",
      "aliases": [
        "ролекс"
      ]
    },
    {
      "name": "Tissot",
      "aliases": [
        "тиссо",
        "тіссо",
        "тиссот"
      ]
    },
    {
      "name": "Omega",
      "aliases": [
        "омега"
      ]
    },
    {
      "name": "Seiko",
      "aliases": [
        "сейко",
        "сейка"
      ]
    },
    {
      "name": "Tudor",
      "aliases": [
        "тудор"
      ]
    },
    {
      "name": "Hamilton",
      "aliases": [
        "гамильтон",
        "гамільтон",
        "хамильтон"
      ]
    },
    {
      "name": "Cartier",
      "aliases": [
        "картье",
        "картьє"
      ]
    },
    {
      "name": "TAG Heuer",
      "aliases": [
        "tagheuer",
        "tag-heuer",
        "таг хоер"
      ]
    },
    {
      "name": "Breitling",
      "aliases": [
        "брайтлинг",
        "брайтлінг"
      ]
    },
    {
      "name": "Longines",
      "aliases": [
        "лонжин",
        "лонжін"
      ]
    },
    {
      "name": "Panerai",
      "aliases": [
        "панерай"
      ]
    },
    {
      "name": "Audemars Piguet",
      "aliases": [
        "AP",
        "одемар пиге"
      ]
    },
    {
      "name": "Vacheron Constantin",
      "aliases": [
        "VC",
        "вашерон"
      ]
    },
    {
      "name": "Patek Philippe",
      "aliases": [
        "патек филипп"
      ]
    },
    {
      "name": "Hublot",
      "aliases": [
        "хабло",
        "убло"
      ]
    },
    {
      "name": "IWC",
      "aliases": []
    },
    {
      "name": "Bvlgari",
      "aliases": [
        "Bulgari",
        "булгари"
      ]
    },
    {
      "name": "Casio",
      "aliases": [
        "касио",
        "касіо",
        "G-Shock",
        "gshock"
      ]
    },
    {
      "name": "Citizen",
      "aliases": [
        "ситизен",
        "сітісен"
      ]
    },
    {
      "name": "Swatch",
      "aliases": [
        "свотч"
      ]
    },
    {
      "name": "Garmin",
      "aliases": [
        "гармин",
        "гармін"
      ]
    },
    {
      "name": "Samsung",
      "aliases": [
        "самсунг"
      ]
    },
    {
      "name": "Apple",
      "aliases": [
        "эппл",
        "епл"
      ]
    },
    {
      "name": "Huawei",
      "aliases": [
        "хуавей"
      ]
    },
    {
      "name": "Blancpain",
      "aliases": [
        "бланпен"
      ]
    },
    {
      "name": "Chopard",
      "aliases": [
        "шопар"
      ]
    },
    {
      "name": "Zenith",
      "aliases": [
        "зенит",
        "зеніт"
      ]
    },
    {
      "name": "Jaeger-LeCoultre",
      "aliases": [
        "JLC",
        "Jaeger LeCoultre"
      ]
    }
  ],
  "models": [
    {
      "id": "tissot-prx",
      "brand": "Tissot",
      "name": "PRX",
      "aliases": [
        "prx"
      ],
      "query": "Tissot PRX",
      "note": "PRX 35mm and 40mm use different attachment options. Choose your case size on the product page.",
      "products": [
        "rubber-strap-compatible-with-luxury-watches-1",
        "stainless-steel-strap-compatible-with-luxury-watches-1",
        "leather-strap-compatible-with-luxury-watches-1"
      ]
    },
    {
      "id": "tissot-prx-40",
      "brand": "Tissot",
      "name": "PRX 40mm",
      "aliases": [
        "prx 40",
        "prx 40mm"
      ],
      "query": "Tissot PRX 40mm",
      "strict": true,
      "note": "40mm is the case diameter. Choose the PRX 40mm / 12mm attachment option, not a generic 40mm strap.",
      "references": [
        "T137.407.11.041.00",
        "T137.410.11.041.00"
      ],
      "sources": [
        "https://www.tissotwatches.com/en-us/T1374071104100.html",
        "https://www.tissotwatches.com/en-us/T1374101104100.html"
      ],
      "products": [
        "rubber-strap-compatible-with-luxury-watches-1",
        "stainless-steel-strap-compatible-with-luxury-watches-1",
        "leather-strap-compatible-with-luxury-watches-1"
      ]
    },
    {
      "id": "tissot-prx-35",
      "brand": "Tissot",
      "name": "PRX 35mm",
      "aliases": [
        "prx 35",
        "prx 35mm"
      ],
      "query": "Tissot PRX 35mm",
      "strict": true,
      "note": "35mm is the case diameter. Choose the PRX 35mm / 11mm attachment option on the product page.",
      "references": [
        "T137.207.11.041.00",
        "T137.210.11.031.00"
      ],
      "sources": [
        "https://www.tissotwatches.com/en-gb/T1372071104100.html",
        "https://www.tissotwatches.com/en-us/T1372101103100.html"
      ],
      "products": [
        "rubber-strap-compatible-with-luxury-watches-1",
        "stainless-steel-strap-compatible-with-luxury-watches-1"
      ]
    },
    {
      "id": "rolex-op-41",
      "brand": "Rolex",
      "name": "Oyster Perpetual 41",
      "aliases": [
        "oyster perpetual 41",
        "oyster perpetual 41mm",
        "op41",
        "op 41"
      ],
      "query": "Rolex Oyster Perpetual 41mm",
      "strict": true,
      "note": "Choose the 21mm option listed for Oyster Perpetual 41. Confirm the reference and end shape before ordering.",
      "references": [
        "124300"
      ],
      "sources": [
        "https://content.rolex.com/dam/new-watches-2020/media/brochures/new-oyster-perpetual/Brochure_Oyster_Perpetual_en.pdf"
      ],
      "products": [
        "deployant-rubber-strap-o-ii-line-series-compatible-with-21mm-watches",
        "rubber-strap-o-ii-line-series-compatible-with-21mm-watches",
        "deployant-rubber-strap-o-ii-series-compatible-with-21mm-watches",
        "rubber-strap-o-ii-series-compatible-with-21mm-watches"
      ]
    },
    {
      "id": "rolex-op-36",
      "brand": "Rolex",
      "name": "Oyster Perpetual 36",
      "aliases": [
        "oyster perpetual 36",
        "oyster perpetual 36mm",
        "op36",
        "op 36"
      ],
      "query": "Rolex Oyster Perpetual 36mm",
      "strict": true,
      "note": "Choose the 20mm option listed for Oyster Perpetual 36. Confirm the reference and end shape before ordering.",
      "references": [
        "126000"
      ],
      "sources": [
        "https://www.rolex.com/watches/oyster-perpetual/m126000-0001"
      ],
      "products": [
        "rubber-strap-o-series-compatible-with-20mm-watches"
      ]
    },
    {
      "id": "tudor-black-bay-bronze",
      "brand": "Tudor",
      "name": "Black Bay Bronze",
      "aliases": [
        "black bay bronze",
        "bb bronze"
      ],
      "query": "Tudor Black Bay Bronze",
      "strict": true,
      "note": "These listings specify Black Bay Bronze with 23mm lug width. Select the 23mm variant on the product page.",
      "references": [
        "M79250BA-0001",
        "M79250BA-0002"
      ],
      "sources": [
        "https://www.tudorwatch.com/en/watches/black-bay-bronze/m79250ba-0001",
        "https://www.tudorwatch.com/en/watches/black-bay-bronze/m79250ba-0002"
      ],
      "products": [
        "rubber-strap-compatible-with-23-mm-watches-wellstraps™",
        "leather-strap-compatible-with-luxury-watches-2"
      ]
    },
    {
      "id": "tudor-pelagos-39",
      "brand": "Tudor",
      "name": "Pelagos 39",
      "aliases": [
        "pelagos 39",
        "pelagos 39mm"
      ],
      "query": "Tudor Pelagos 39",
      "strict": true,
      "note": "Pelagos 39 has 21mm lugs. Pelagos 42 straps marked 22mm are a different fit. Ask us to check your reference.",
      "references": [
        "M25407N-0001"
      ],
      "sources": [
        "https://www.tudorwatch.com/en/watches/pelagos/m25407n-0001"
      ],
      "products": []
    },
    {
      "id": "hamilton-ventura-auto",
      "brand": "Hamilton",
      "name": "Ventura Auto H24515551",
      "aliases": [
        "ventura h24515551"
      ],
      "query": "Hamilton H24515551",
      "strict": true,
      "note": "Choose the strap listed for Ventura H24515551 with 21mm attachment. Confirm the attachment shape on the product page.",
      "references": [
        "H24515551"
      ],
      "sources": [
        "https://www.hamiltonwatch.com/en-us/h24515551-ventura-auto.html"
      ],
      "products": [
        "cowhide-leather-watch-strap-21mm-wellstraps™"
      ]
    },
    {
      "id": "moonswatch",
      "brand": "Swatch",
      "name": "MoonSwatch",
      "aliases": [
        "moonswatch",
        "moon swatch",
        "мунсвотч"
      ],
      "query": "MoonSwatch",
      "note": "These listings specify MoonSwatch with 20mm lug width. Check the selected variant and buckle.",
      "products": [
        "rubber-strap-compatible-with-20mm-watches-wellstraps™-2",
        "premium-nylon-watch-strap-20-mm-multiple-colors-wellstraps™-1",
        "rubber-watch-strap-magnetic-buckle-20-mm-wellstraps™"
      ]
    }
  ]
};
